import React, { useState } from "react";
import "./project4.css";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";

function Project4() {
  const [main, setMain] = useState(false);
  const gotoMainPage = () => {
    setMain(true);
  };

  return (
    <>
      {!main ? (
        <div className="body">
          <div className="headerP1">
            <h2 id="Title">Shell</h2>
            <div id="P1Github">
              <a
                href="https://github.com/AkhilTheBoss/Shell"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button variant="secondary">Github</Button>
              </a>
            </div>
            <div id="mainPage">
              <Button variant="primary" onClick={gotoMainPage}>
                Main Page
              </Button>
            </div>
          </div>
          <br />
          <h4 className="Heading">Introduction</h4>
          <p className="Content">
            Created a command-line interpreter that accepts commands from the
            user and executes them.
          </p>
          <h4 className="Heading">Functionality</h4>
          <p className="Content">
            <strong>Command Execution:</strong> When the shell is ready to
            accept input from the user, it must print sshell@ucd$. At this point
            the user must type a command. The shell will print the output of the
            command and a completion message. The shell also displays a new
            prompt for a new input command line to be supplied.
            <div>Example:</div>
            <div className="example">
              <div>sshell@ucd$ echo Hello world</div>
              <div className="tab">
                <div>Hello world</div>
                <div>+ completed 'echo Hello world'</div>
              </div>
              <div>sshell@ucd$</div>
            </div>
          </p>
          <p className="Content">
            <strong>Piping:</strong> The pipe sign is indicated by using the
            character | and allows multiple commands to be connected to each
            other within the same command line. When the shell encounters a pipe
            sign, it indicates that the output of the command located before the
            pipe sign must be connected to the input of the command located
            after the pipe sign. We assume that there can be up to three pipe
            signs on the same command line to connect multiple commands to each
            other.
            <div>Example:</div>
            <div className="example">
              <div>sshell@ucd$ echo Your line of text goes here | wc -w</div>
              <div className="tab">
                <div>6</div>
                <div>
                  + completed 'echo Your line of text goes here | wc -w'{" "}
                </div>
              </div>
              <div>sshell@ucd$</div>
            </div>
          </p>
          <p className="Content">
            <strong>Output redirection:</strong> The standard output redirection
            is indicated by using the character > followed by a file name. Such
            redirection implies that the command located right before > is to
            write its output to the specified file instead of the shell’s
            standard output
            <div>Example:</div>
            <div className="example">
              <div>sshell@ucd$ echo Hello world>file</div>
              <div className="tab">
                <div>+ completed 'echo Hello world>file'</div>
              </div>
              <div>sshell@ucd$ cat file</div>
              <div className="tab">
                <div>Hello world</div>
                <div>+ completed 'cat file'</div>
              </div>
              <div>sshell@ucd$</div>
            </div>
          </p>
          <p className="Content">
            <strong>Input redirection:</strong> The standard input redirection
            is indicated by using the meta-character &lt; followed by a file
            name. Such redirection implies that the command located right before
            &lt; is to read its input from the specified file instead of the
            shell’s standard input.
            <div>Example:</div>
            <div className="example">
              <div>sshell@ucd$ cat file</div>
              <div className="tab">
                <div>titi</div>
                <div>toto</div>
                <div>+ completed 'cat file'</div>
              </div>
              <div>sshell@ucd$ grep toto&lt;file</div>
              <div className="tab">
                <div>toto</div>
                <div>+ completed 'grep toto&lt;file'</div>
              </div>
              <div>sshell@ucd$</div>
            </div>
          </p>
          <p className="Content">
            <strong>Directory Stack:</strong> Developed a directory stack, using
            a stack data structure. It keeps track of the directories you visit,
            allowing you to easily switch back and forth between them. You can
            push the directories onto the stack, pop them, or even list all of
            them present on the stack.
            <ul>
              <li>
                pushd acts as cd but also pushed the current directory to a
                stack before changing the directory.
              </li>
              <li>
                popd pops the latest directory that was pushed onto the stack,
                if any, and changes back to it.
              </li>
              <li>
                dirs lists the stack of remembered directories. The listing
                always starts with the directory that the shell is currently in.
              </li>
            </ul>
            <div>Example:</div>
            <div className="example">
              <div>sshell@ucd$ dirs</div>
              <div className="tab">
                <div>/home/jporquet</div>
                <div>+ completed 'dirs'</div>
              </div>
              <div>sshell@ucd$ pushd teach</div>
              <div className="tab">
                <div>+ completed 'pushd teach'</div>
              </div>
              <div>sshell@ucd$ pwd</div>
              <div className="tab">
                <div>/home/jporquet/teach</div>
                <div>+ completed 'pwd'</div>
              </div>
              <div>sshell@ucd$ dirs</div>
              <div className="tab">
                <div>/home/jporquet/teach</div>
                <div>/home/jporquet</div>
                <div>+ completed 'dirs'</div>
              </div>
              <div>sshell@ucd$ popd</div>
              <div className="tab">
                <div>+ completed 'popd'</div>
              </div>
              <div>sshell@ucd$ pwd</div>
              <div className="tab">
                <div>/home/jporquet</div>
                <div>+ completed 'pwd'</div>
              </div>
              <div>sshell@ucd$</div>
            </div>
          </p>
          <h4 className="Heading">Scope For Improvement</h4>
          <p className="Content">
            Improved piping functionality: The current shell has a limit of
            processing up to three pipe symbols, but there is room for
            improvement to enable it to handle additional pipe symbols.
          </p>
        </div>
      ) : (
        <App />
      )}
    </>
  );
}

export default Project4;
